// extracted by mini-css-extract-plugin
export default {"header":"header_header__fYAMi","logo":"header_logo__ltpn7","desktopUserAvatar":"header_desktopUserAvatar__CaMw0","hamburgerMenu":"header_hamburgerMenu__s8eOn"};